<template lang="pug">
  .try-it-on.clearfix
    .xs-12
      .xs-12.md-6
        .xs-12
          ymk-wrap(v-if="tryItMode" :code="ymkProductCode" @loaded="ymkLoaded = true" @closed="ymkLoaded = false")
          split-image-compare.view-on-model(v-else :left-image="compareProduct.imagery ? compareProduct.imagery.backie : {}" :right-image="selectedProduct.imagery ? selectedProduct.imagery.backie : {}")

        .desc-wrap.xs-12.text-center
          p.semi-bold.xs-f-xmedium.max-at-tweak(v-if="compareProduct && compareProduct.desc && !(selectedProduct && selectedProduct.desc)") {{compareProduct.desc.short}}
          p.semi-bold.xs-f-xmedium.max-at-tweak(v-else-if="selectedProduct && selectedProduct.desc") {{selectedProduct.desc.short}}
      
      .right-side.xs-12.md-6(v-if="$root.moreColorOptions")
        .xs-12.a-box-xs-4x3.a-box-md-1x1
          .get-it-right.a-box-content
            .title-wrap.xs-12.text-center.xs-hide.sm-hide
              p.xs-f-xlarge.max-at-tweak Let's Get It Right
            
            .controls.xs-12(:class="{ disabled: !controlsEnabled }")
              .color-tags-wrap.xs-12
                horizontal-selector.inner-tags-wrap(:selected-index="selectedTagIndex" :center-mode="true" :drag-mode="true" @swipeLeft="swipeLeft" @swipeRight="swipeRight")
                  button.color-tag.btn-reset.upper.semi-bold.color-slate.xs-f-xsmall.max-at-tweak(type="button" v-for="tag in colorTags" :key="tag.key_name" @click="selectedTagKey = tag.key_name" :class="{selected: selectedTagKey == tag.key_name}" data-mr-ass="color-tag")
                    span.non-focusable(tabindex="-1") {{tag.name}}

              .triangle.xs-12

              .swatches.xs-12
                horizontal-selector.swatches-wrap(:selected-index="selectedSwatchIndex")
                  button.btn-reset.swatch-wrap.swatch-tone(type="button" v-for="swatch in swatches" :key="swatch.productId" @click="selectedProductId = swatch.productId" :class="{selected: swatchSelected(swatch.productId), 'bounce-complete': bounced}" data-mr-ass="color-swatch")
                    .non-focusable(tabindex="-1")
                      .swatch
                        .swatch-inner
                          img.full-width(:src="swatch.image.url" alt="")
                      span.swatch-text.color-slate.xs-f-xxsmall.max-at-tweak(v-html="swatch.label")

            .view-toggle-wrap.text-center
              button.view-toggle.upper.semi-bold.color-purple.xs-f-small.max-at-tweak(v-if="!tryItMode" type="button" @click="tryItMode = true" data-mr-ass="try-it-on")
                i.icon-camera.xs-f-large.max-at-tweak
                | &nbsp;try it on
              button.view-toggle.upper.semi-bold.color-purple.xs-f-small.max-at-tweak(v-else type="button" @click="tryItMode = false" data-mr-ass="view-on-model")
                | view on model

        .done-cancel.xs-12.text-center
          button.cta.xs-6(type="button" @click="cancel" data-mr-ass="cancel-more-colors")
            .non-focusable(tabindex="-1")
              .cancel
                .icon.icon-x
                span.upper.semi-bold cancel
          button.cta.xs-6(type="button" @click="selectColor" data-mr-ass="save-more-colors")
            .non-focusable(tabindex="-1")
              .done
                .icon.icon-check-nobox
                span.upper.semi-bold select

</template>

<script>
  import vueProductSvc from '../services/vueProductSvc.js';

  export default {
    props: {
      compareProductId: {
        type: [String, Number]
      },
      viewOnModel: {
        type: Boolean
      }
    },

    data() {
      return {
        isMounted: false,
        bounced: false,
        ymkLoaded: false,
        tryItMode: true,
        selectedTagKey: null,
        selectedProductId: null
      }
    },

    computed: {
      moreColorOptions() {
        return this.$root.moreColorOptions;
      },

      colorMatches() {
        return this.$root.colorMatches;
      },

      formatedColorMatches() {
        return this.$root.formatedColorMatches;
      },

      recommendationsTag() {
        var tag = {
          key_name: 'matches',
          name: 'Recommendations',
          products: []
        };

        if (this.colorMatches) {
          Object.keys(this.colorMatches).forEach(key => {
            if (this.colorMatches[key] && this.colorMatches[key].id) {
              tag.products.push(this.colorMatches[key].id);
            }
          });
        }

        if (!tag.products.length) {
          return null;
        }

        return tag;
      },

      colorTags() {
        // add fake tag for recommendations
        var tags = [];

        if (this.recommendationsTag) {
          tags.push(this.recommendationsTag);
        }

        if (this.moreColorOptions && this.moreColorOptions.colorTags) {
          tags = tags.concat(this.moreColorOptions.colorTags);
        }

        return tags;
      },

      selectedTagIndex() {
        var index = 0;
        
        this.colorTags.forEach((tag, tagIndex) => {
          if (tag.key_name == this.selectedTagKey) {
            index = tagIndex;
          }
        });

        return index;
      },

      swatches() {
        var swatchArray = [];

        if (this.selectedTag && this.selectedTag.key_name == 'matches' && this.formatedColorMatches) {
          this.formatedColorMatches.forEach(match => {
            swatchArray.push({
              productId: match.product.id,
              image: match.product.imagery.toneSwatch,
              label: match.label
            })
          });
        } else {
          if (this.moreColorOptions) {
            this.moreColorOptions.products.forEach(product => {
              if (this.productInCategory(product.categories)) {
                swatchArray.push({
                  productId: product.id,
                  image: product.imagery.toneSwatch,
                  label: product.colorTone
                });
              }
            });
          }
        }

        return swatchArray;
      },

      selectedSwatchIndex() {
        if (!this.swatches || !this.swatches.length) {
          return 0;
        }
        var index = 0;

        this.swatches.forEach((swatch, swatchIndex) => {
          if (this.selectedProductId) {
            if (swatch.productId == this.selectedProductId) {
              index = swatchIndex;
            }
          } else if (this.compareProductId) {
            if (swatch.productId == this.compareProductId) {
              index = swatchIndex;
            }
          }
        });

        return index;
      },

      selectedTag() {
        if (!this.moreColorOptions) {
          return {};
        }
        return this.colorTags.find(tag => tag.key_name == this.selectedTagKey) || this.colorTags[0];
      },

      selectedProduct() {
        var selected = {};
        
        if (!this.moreColorOptions || !this.selectedProductId) {
          return selected;
        }

        if (this.selectedTag && this.selectedTag.key_name == 'matches' && this.formatedColorMatches) {
          this.formatedColorMatches.forEach(match => {
            if (match.product.id == this.selectedProductId && match.product.id != this.compareProductId) {
              selected = match.product;
            }
          });
        } else {
          selected = this.moreColorOptions.products.find(product => {
            return product.id == this.selectedProductId && product.id != this.compareProductId;
          }) || {};
        }

        return selected;
      },

      ymkProductCode() {
        return this.selectedProduct.code || this.compareProduct.code || null;
      },

      innerTagsLeftMargin() {
        if (!this.isMounted || !this.moreColorOptions || !this.selectedTag || !this.$refs.innerTagsWrap) {
          return false;
        }
        if (this.$root.windowData.width) {
          var tagIndex = 0;
          this.colorTags.forEach((tag, index) => {
            if (tag.key_name == this.selectedTag.key_name) {
              tagIndex = index;
            }
          });
          var selfWidth = $(this.$refs.outerTagsWrap.$el).outerWidth();
          var totalWidth = 0;
          for (var x = 0; x < this.$refs.innerTagsWrap.children.length; x++) {
            if (x < tagIndex) {
              totalWidth += $(this.$refs.innerTagsWrap.children[x]).outerWidth();
            }
            if (x == tagIndex) {
              totalWidth += $(this.$refs.innerTagsWrap.children[x]).outerWidth() / 2;
            }
          }
          return -1 * totalWidth + (selfWidth / 2) + 'px';
        }
      },

      controlsEnabled() {
        return !this.tryItMode || (this.tryItMode && this.ymkLoaded);
      }
    },

    asyncComputed: {
      compareProduct: {
        get() {
          if (this.moreColorOptions) {
            return vueProductSvc.getProductById({ id: this.compareProductId }).then(res => {
              this.colorTags.forEach(tag => {
                tag.products.forEach(prodId => {
                  if (prodId == res.data.id) {
                    this.selectedTagKey = tag.key_name;
                  }
                });
              });
              return res.data;
            });
          } else {
            return Promise.resolve({}).then(res => res);
          }
        },
        default() {
          return {};
        }
      }
    },

    methods: {
      productInCategory(productsCategoryIds) {
        return !!productsCategoryIds.find(id => id == this.selectedTag.id);
      },

      swipeLeft(num) {
        num = Math.ceil(num);
        if (this.colorTags[this.selectedTagIndex + num]) {
          this.selectedTagKey = this.colorTags[this.selectedTagIndex + num].key_name;
        }
      },

      swipeRight(num) {
        num = Math.ceil(num);
        if (this.colorTags[this.selectedTagIndex - num]) {
          this.selectedTagKey = this.colorTags[this.selectedTagIndex - num].key_name;
        }
      },

      swatchSelected(productId) {
        return productId == this.selectedProductId || (!this.selectedProductId && productId == this.compareProductId);
      },

      selectColor() {
        if (this.selectedProduct && this.selectedProduct.id && this.selectedProduct.id != this.compareProductId) {
          this.$emit('select', this.selectedProduct);
        } else {
          this.$emit('cancel');
        }
      },

      cancel() {
        this.$emit('cancel');
      }
    },

    mounted() {
      this.isMounted = true;
      if (this.viewOnModel) {
        this.tryItMode = false;
      }
      setTimeout(() => {
        this.bounced = true;
      }, 1000);
    }
  }
</script>

<style lang="stylus">
  .try-it-on
    .desc-wrap
      padding 1.5em 3%
      
    .right-side
      background-color color-white
      
      .controls
        &.disabled
          pointer-events none
          opacity 0.5
      
    .title-wrap
      padding-top 3em
      padding-bottom 2em
      
    .color-tags-wrap
      overflow hidden
      background-color color-gray-light
      border-top 1px solid color-fog-light
      border-bottom 1px solid color-fog-light
      
      .inner-tags-wrap
        white-space nowrap
        transition(margin-left 400ms ease-in-out)
        
        .color-tag
          background-color transparent
          border none
          
          .non-focusable
            padding 1.25em 1em
          
          &.selected
            color color-mr-purple
              
    .triangle
      position relative
      
      &:before
      &:after
        content ''
        position absolute
        left 50%
        width 0px
        height 0px
        border 20px solid transparent
        border-bottom-width 16px
        bottom 0
        margin-left -20px
        pointer-events none
        
      &:before
        bottom 1px
        border-bottom-color color-fog-light
        
      &:after
        border-bottom-color color-white
      
    .swatches
      text-align left
      padding 0.5em 0
      padding-bottom 3.5em
      
      .swatches-wrap
        position relative
      
      .swatch-wrap
        display inline-block
        vertical-align top
        width 4.8em
        padding-left 0.15em
        padding-right 0.15em
        text-align center
        white-space normal
        
        .swatch
          display inline-block
          width 4.5em
          height 4.5em
          border-radius 50%
          padding 4px
          border 4px solid color-white
          
          .swatch-inner
            position relative
            width 100%
            height 100%
            border-radius 50%
            overflow hidden
            
          
        &.selected
          .swatch
            border-color color-mr-blue
        
        .swatch-text
          display inline-block
          margin-top 0.25em
      
    .view-toggle-wrap
      position absolute
      left 0
      right 0
      bottom 0
      border-top 1px solid color-fog-light
      border-bottom 1px solid color-fog-light
      
      .view-toggle
        padding 1em
        width 100%
        background-color transparent
        border none
      
    .done-cancel
      .icon
        display inline-block
        margin-right 5px
      
      .cta
        color color-mr-purple
        text-align center
        margin 1.75em 0
        background-color transparent
        border none
        
        .non-focusable
          padding 1em
        
        &:first-child
          border-right 1px solid color-fog-light
    
    @media mq-mobile
      .view-on-model
        padding 0 10%
        background-color color-fog-light
        
      .right-side
        margin-bottom 5.5em
        
      .done-cancel
        position fixed
        left 0
        right 0
        bottom 0
        background-color color-white
        border-top 1px solid color-fog-light
          
    @media mq-tablet-less
      .done-cancel
        .cta
          margin 0.5em 0
         
</style>
